import { Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";

// Helper to detect if we're in local development environment
const isLocalDevelopment = () => {
  if (typeof globalThis.window === 'undefined') return false;
  
  const hostname = globalThis.window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isNamedDevelopmentHost = hostname === 'anuj.dev.sofmen.com';
  const isPrivateLanHost =
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);
  
  // Check if we're in development mode
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  // In local development, skip redirects to allow testing without token
  return (isLocalhost || isNamedDevelopmentHost || isPrivateLanHost) && isDevelopment;
};

// Helper to treat refactor deployments like local development
const isRefactorEnvironment = () => process.env.REACT_APP_ENV === 'refactor';

const Protected = () => {
  const token = localStorage.getItem("token");
  const isLocalDev = isLocalDevelopment() || isRefactorEnvironment();

  useEffect(() => {
    if (!token && typeof globalThis.window !== 'undefined' && !isLocalDev) {
      const marketingUrl = process.env.REACT_APP_BASE_URL_MARKETING || '/';
      globalThis.window.location.href = marketingUrl;
    }
  }, [token, isLocalDev]);

  if (!token && isLocalDev) {
    return <Outlet />;
  }

  if (!token) {
    return null;
  }

  return <Navigate to="/stores" />;
};

export default Protected;
